import * as React from 'react';
import DataGrid from '../form/DataGrid';

export default function ChemistryDataGrid(props = {}) {
  
  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        resource="chemistry"
        initialColumnVisibilityModel={{
          createdAt: false,
        }}
        {...props}
      />
    </div>
  );
}